<template>
    <UApp :locale="locales.en">
        <component :is="layout">
            <router-view />
        </component>
    </UApp>
</template>

<script lang="ts" setup>
    import { computed } from 'vue'
    import { useRoute } from 'vue-router'
    import * as locales from '@nuxt/ui/locale'

    import Default from '@/layouts/Default.vue'
    import Blank   from '@/layouts/Blank.vue'

    const route = useRoute()

    const layouts = { Default, Blank }
    const layout  = computed(() => layouts[(route.meta.layout as keyof typeof layouts) ?? 'Default'])
</script>
